/* eslint-disable complexity */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import isEqual from 'lodash/isEqual';
import PropTypes from 'prop-types';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Image from '@tcp/core/src/components/common/atoms/Image';
import {
  getIconPath,
  getLocator,
  getDateRange,
  getFormattedDate,
  getSelectedShipment,
  getDateObject,
} from '@tcp/core/src/utils';
import {
  getLabelFromCopyOrFromTranslation,
  getDynamicLabelValues,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import AccountCommonLabels, {
  CHECKOUT_LABELS,
} from '@tcp/core/src/components/features/account/common/labels/AccountCommon.labels';
import EddDynamicStore from '@tcp/core/src/components/features/CnC/common/molecules/EddComponent/container/EddComponentDynamicStore.js';
import { getEddSessionState } from '@tcp/core/src/utils/utils.web';
import { displayEmptyToNA } from '@tcp/core/src/utils/loyalty.util';
import { getItemEDD, filterEddItemsById } from './EddComponent.view.utils';
import Styles, { ExpeditedBenefit } from '../styles/EddComponent.style';
import BAGPAGE_LABELS from '../../../../BagPage/container/Bagpage.labels';
import { checkForFreeShipping } from '../../../../BagPage/views/Bagpage.utils';
import { getRangeDateText } from '../../SPCShipmentMethods/views/ShipmentMethods.view';

const primaryText = 'text.primary';

class EddComponentView extends React.Component {
  async componentDidMount() {
    await EddDynamicStore();
    const { fetchEdd } = this.props;
    fetchEdd();
  }

  shouldComponentUpdate(nextProps) {
    return !isEqual(nextProps, this.props);
  }

  componentDidUpdate(prevProps) {
    const { fetchEddUpdate, updateShipmentCode, selectedShipment, isFetchingState } = this.props;
    const { selectedShipment: prevSelectedShipment } = prevProps;
    if (!isFetchingState) {
      // FIXME: Edd call should be either trigger from parent or saga.
      fetchEddUpdate();
    }
    if (selectedShipment !== prevSelectedShipment) {
      updateShipmentCode(selectedShipment);
    }
  }

  getPrefixLabel = (eddLabels, myBagSpc, rangeDate, spc, fulfillmentGroup) => {
    let prefix;
    if (myBagSpc && rangeDate && !fulfillmentGroup) {
      prefix = eddLabels?.estimateToArriveBy;
    } else if (myBagSpc && !rangeDate) {
      prefix = '';
    } else if (spc) {
      prefix = eddLabels?.preOrderItemEdd;
    } else {
      prefix = eddLabels?.arrivesBy;
    }
    return prefix;
  };

  getShippingMethodDisplayName = (myBagSpc, rangeDate, shippingMethodSelected) => {
    return myBagSpc || rangeDate ? shippingMethodSelected?.displayName : '';
  };

  formatDate = (dt = '') => {
    if (dt?.includes('-')) {
      let [year, month, day] = dt.split('-');
      year = `${year}`;
      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;
      return [year, month, day];
    }

    const formattedDate = getDateObject(dt);
    const year = `${formattedDate.getFullYear()}`;
    let month = `${formattedDate.getMonth() + 1}`;
    let day = `${formattedDate.getDate()}`;
    if (month.length < 2) month = `0${month}`;
    if (day.length < 2) day = `0${day}`;
    return [year, month, day];
  };

  renderHolidayLabel = (eddLabels) => {
    const { orderEddDates, selectedShipment } = this.props;
    const holidayDate = this.formatDate(eddLabels?.holidayDate);
    const shippingDate = this.formatDate(
      orderEddDates?.maxDates?.[selectedShipment || getSelectedShipment(orderEddDates, '')]
    );
    if (holidayDate <= shippingDate) return true;
    return false;
  };

  checkIfShipmentAfterHoliday = (eddLabels) => {
    const { orderEddDates } = this.props;
    const holidayDate = this.formatDate(eddLabels?.holidayDate);
    const rushShipmentDate =
      orderEddDates?.maxDates?.U1DS && this.formatDate(orderEddDates?.maxDates?.U1DS);
    const rushShipmentDateExceptionState =
      orderEddDates?.maxDates?.U1AK && this.formatDate(orderEddDates?.maxDates?.U1AK);

    if (
      (rushShipmentDate >= holidayDate && rushShipmentDate[0] !== 'NaN') ||
      (rushShipmentDateExceptionState >= holidayDate && rushShipmentDateExceptionState[0] !== 'NaN')
    ) {
      return true;
    }
    return false;
  };

  renderHolidayShipment = (shipMethodDisplayName, eddLabels) => {
    let holidayShipmentMethod;
    holidayShipmentMethod = shipMethodDisplayName;
    const { orderEddDates } = this.props;
    const holidayDate = this.formatDate(eddLabels?.holidayDate);
    const freeShipmentDate =
      orderEddDates?.maxDates?.UGNR && this.formatDate(orderEddDates?.maxDates?.UGNR);
    const expressShipmentDate =
      orderEddDates?.maxDates?.U2DY && this.formatDate(orderEddDates?.maxDates?.U2DY);
    const expressShipmentDateExceptionState =
      orderEddDates?.maxDates?.U2AK && this.formatDate(orderEddDates?.maxDates?.U2AK);

    const rushShipmentDate =
      orderEddDates?.maxDates?.U1DS && this.formatDate(orderEddDates?.maxDates?.U1DS);
    const rushShipmentDateExceptionState =
      orderEddDates?.maxDates?.U1AK && this.formatDate(orderEddDates?.maxDates?.U1AK);

    if (freeShipmentDate >= holidayDate) {
      if (expressShipmentDate < holidayDate || expressShipmentDateExceptionState < holidayDate) {
        holidayShipmentMethod = 'Express Shipping';
      } else if (rushShipmentDate < holidayDate || rushShipmentDateExceptionState < holidayDate) {
        holidayShipmentMethod = 'Rush Shipping';
      }
      return holidayShipmentMethod;
    }

    if (
      !orderEddDates?.maxDates?.UGNR &&
      orderEddDates?.maxDates?.U2AK &&
      expressShipmentDateExceptionState >= holidayDate
    ) {
      return 'Rush Shipping';
    }

    return false;
  };

  renderExpeditedProcessing = (checkoutLabels) => {
    const { myBagSpc, spc, currentTier, isFromShippingExpanded } = this.props;
    const tierVal = currentTier && currentTier.replace('-', ' ');

    if (!myBagSpc || !spc || isFromShippingExpanded) return null;

    return (
      <ExpeditedBenefit>
        <div className="expedited-wrapper">
          <Image height="11px" width="14px" alt="color-star" src={getIconPath('color-star')} />
          <BodyCopy fontFamily="secondary" fontSize="fs12" fontWeight="semibold">
            {renderLabel(
              checkoutLabels?.bagPage?.lbl_expedited_processing,
              'lbl_expedited_processing'
            ).replace('##currentTier##', displayEmptyToNA(currentTier, tierVal))}
          </BodyCopy>
        </div>
      </ExpeditedBenefit>
    );
  };

  // eslint-disable-next-line sonarjs/cognitive-complexity
  renderRangeView = (selectedShipment, subtitle, eddLabels) => {
    const {
      className,
      isShipping,
      fontSize,
      textAlign,
      orderEddDates,
      showIcon,
      myBagSpc,
      shippingMethodSelected,
      spc,
      fulfillmentGroup,
      isFromShippingExpanded,
      holidayMessageEnabled,
      isMobileWebProductTileCheckout,
      freeShippingThershold,
      shippingTotal,
      isDynamicFreeShippingEnabled,
      shipments,
    } = this.props;
    const newSubtitle = subtitle === 'FREE Standard Shipping' ? 'FREE Shipping' : subtitle;
    const rangeDate = orderEddDates ? getDateRange(orderEddDates, selectedShipment, '') : null;
    const rangeDateWithoutDay = orderEddDates
      ? getDateRange(orderEddDates, selectedShipment, '', true)
      : null;
    let shipMethodDisplayName = this.getShippingMethodDisplayName(
      myBagSpc,
      rangeDate,
      shippingMethodSelected
    );
    const shouldRenderHolidayLabel = this.renderHolidayLabel(eddLabels);
    const isShipmentDeliveredAfterHoliday = this.checkIfShipmentAfterHoliday(eddLabels);
    const holidayShipmentMethodNames = this.renderHolidayShipment(shipMethodDisplayName, eddLabels);
    let colorStyleDate = '';
    if (!shouldRenderHolidayLabel) {
      colorStyleDate = 'green.500';
    } else if (shouldRenderHolidayLabel) {
      colorStyleDate = 'red.500';
    } else colorStyleDate = primaryText;

    const colorStyle = myBagSpc || spc ? 'green.500' : primaryText;
    const holidayLabel = eddLabels?.holidayMessage?.split('#shippingMethod');
    const priorityShipmentDate = orderEddDates?.maxDates?.PMDC
      ? this.formatDate(orderEddDates?.maxDates?.PMDC)
      : ['NaN'];
    const isPriorityShipping =
      priorityShipmentDate?.[0] !== 'NaN' ||
      shipMethodDisplayName?.toUpperCase() === 'PRIORITY SHIPPING' ||
      shipMethodDisplayName?.toUpperCase() === 'USPS SHIPPING';
    const isFreeShippingEligible = checkForFreeShipping({
      freeShippingThershold,
      shippingTotal,
      isDynamicFreeShippingEnabled,
      shipments,
      selectedShipmentCode: shippingMethodSelected?.code,
    });
    if (!isFreeShippingEligible) {
      shipMethodDisplayName = shipMethodDisplayName.replace('FREE', '');
    }
    return myBagSpc ? (
      <>
        {myBagSpc && shipMethodDisplayName && !fulfillmentGroup && !isFromShippingExpanded && (
          <BodyCopy
            component="div"
            fontWeight="extrabold"
            className={`estimated-shipping-date ${rangeDate ? ' ' : 'free-standard-shipping'}`}
            fontFamily="secondary"
            fontSize="fs14"
          >
            {shipMethodDisplayName}
          </BodyCopy>
        )}
        {rangeDate && (
          <BodyCopy
            component="div"
            className={`my-bag-edd-text ${className}`}
            fontSize={fontSize || 'fs14'}
            textAlign={textAlign || 'center'}
          >
            {showIcon && (
              <Image
                alt="Default Favourite List"
                src={getIconPath('fast-shipping')}
                className="sth-icon hide-on-desktop hide-on-tablet"
                dataLocator={getLocator('sth-icon')}
              />
            )}
            {!isFromShippingExpanded && (
              <>
                <BodyCopy
                  component="span"
                  className={isShipping ? 'estimated-shipping-speed' : ''}
                  fontFamily="secondary"
                  color={colorStyle}
                >
                  {this.getPrefixLabel(eddLabels, myBagSpc, rangeDate, spc, fulfillmentGroup)}
                </BodyCopy>
                <BodyCopy
                  component="span"
                  fontWeight="extrabold"
                  className="estimated-shipping-date"
                  text={rangeDate}
                  fontFamily="secondary"
                  color={
                    !isShipmentDeliveredAfterHoliday &&
                    spc &&
                    !isPriorityShipping &&
                    holidayMessageEnabled
                      ? colorStyleDate
                      : colorStyle
                  }
                >
                  {fulfillmentGroup ? rangeDateWithoutDay : rangeDate}
                </BodyCopy>
              </>
            )}
            {!isShipmentDeliveredAfterHoliday &&
              !isPriorityShipping &&
              spc &&
              holidayMessageEnabled &&
              (shouldRenderHolidayLabel ? (
                <>
                  <BodyCopy className="holiday-message-wrapper">
                    <BodyCopy
                      component="div"
                      className="holiday-message"
                      fontFamily="secondary"
                      color={colorStyle}
                    >
                      {holidayLabel[0]}
                    </BodyCopy>
                    &nbsp;
                    <BodyCopy
                      component="div"
                      className="holiday-message"
                      fontFamily="secondary"
                      fontWeight="bold"
                      color={colorStyle}
                    >
                      {holidayShipmentMethodNames}
                    </BodyCopy>
                    &nbsp;
                    <BodyCopy
                      component="div"
                      className="holiday-message"
                      fontFamily="secondary"
                      color={colorStyle}
                    >
                      {holidayLabel[1]}
                    </BodyCopy>
                  </BodyCopy>
                </>
              ) : (
                <BodyCopy
                  component="div"
                  className="holiday-message"
                  fontFamily="secondary"
                  color={colorStyle}
                >
                  {eddLabels?.holidayMessageConfirmation}
                </BodyCopy>
              ))}
          </BodyCopy>
        )}
        {subtitle && fulfillmentGroup && !rangeDate && (
          <BodyCopy component="div" className={className}>
            <BodyCopy
              fontFamily="secondary"
              fontSize="fs12"
              fontWeight="extrabold"
              component="p"
              className="subtitle"
            >
              {newSubtitle}
            </BodyCopy>
          </BodyCopy>
        )}
        {!subtitle &&
          !fulfillmentGroup &&
          !rangeDate &&
          shippingMethodSelected?.shippingSpeed &&
          !isFromShippingExpanded && (
            <BodyCopy component="div" className={className}>
              <BodyCopy
                component="span"
                fontWeight="bold"
                fontFamily="secondary"
                color={colorStyle}
                fontSize={isMobileWebProductTileCheckout && spc ? 'fs12' : 'fs14'}
              >
                {getRangeDateText(shippingMethodSelected.shippingSpeed)}
              </BodyCopy>
            </BodyCopy>
          )}
      </>
    ) : (
      <>
        {!rangeDate && (
          <BodyCopy component="div" className={className}>
            <BodyCopy
              fontFamily="secondary"
              fontSize="fs12"
              fontWeight="semibold"
              component="span"
              className="estimated-shipping-speed"
            >
              {subtitle}
            </BodyCopy>
          </BodyCopy>
        )}
      </>
    );
  };

  getEddDateStyle = () => {
    const { spc, spcBag } = this.props;
    let styleName = '';
    if (spc) {
      styleName = 'myBagSpc';
    } else if (!spcBag) {
      styleName = 'elem-pt-MED new-product-tile-edd';
    }
    return styleName;
  };

  // eslint-disable-next-line sonarjs/cognitive-complexity
  renderDateView = (eddItemsForId, eddLabels) => {
    const {
      showIcon,
      className,
      fontSize,
      selectedShippingMethod,
      spcBag,
      newBag,
      placeHolderText,
      isMobileWebProductTile,
      isDesktopProductTileCleanUpDisabled,
      showToggleLink,
    } = this.props;
    const itemEdd = getItemEDD(eddItemsForId, selectedShippingMethod);
    const color = spcBag || newBag ? 'green.500' : primaryText;
    return itemEdd ? (
      <BodyCopy component="div" className={className}>
        <div className={isDesktopProductTileCleanUpDisabled ? '' : 'edd-wrapper-new-tile'}>
          <BodyCopy component="div" className={this.getEddDateStyle()}>
            {showIcon && !isMobileWebProductTile && (
              <Image
                alt={`${eddLabels.estimateToArriveBy} ${getFormattedDate(itemEdd)}`}
                src={`${
                  newBag ? getIconPath('bag-ship-to-home-black') : getIconPath('fast-shipping')
                }`}
                className="sth-icon eddIcon"
                dataLocator={getLocator('sth-icon')}
              />
            )}
            <BodyCopy
              fontFamily="secondary"
              fontSize={isMobileWebProductTile ? 'fs12' : fontSize || 'fs14'}
              fontWeight="semibold"
              component="span"
              color={color}
            >
              {isMobileWebProductTile ? eddLabels.estimateToArriveBy : eddLabels.arrivesBy}
            </BodyCopy>
            <BodyCopy
              fontFamily="secondary"
              className="estimated-shipping-date"
              fontSize={isMobileWebProductTile ? 'fs12' : fontSize || 'fs14'}
              fontWeight="extrabold"
              component="span"
              color={color}
            >
              {getFormattedDate(itemEdd, newBag)}
            </BodyCopy>
          </BodyCopy>
          {!isDesktopProductTileCleanUpDisabled && showToggleLink && (
            <BodyCopy
              className="color-fit-size-separator"
              fontFamily="secondary"
              component="span"
              fontSize="fs12"
              color="gray.500"
            >
              |
            </BodyCopy>
          )}
        </div>
      </BodyCopy>
    ) : (
      <>
        {placeHolderText && (
          <BodyCopy
            fontFamily="secondary"
            fontSize={fontSize || 'fs14'}
            component="p"
            textAlign="center"
            color="green.500"
          >
            {placeHolderText}
          </BodyCopy>
        )}
      </>
    );
  };

  render() {
    const {
      itemsWithEdd,
      itemIdprop,
      isRangeDate,
      selectedShipment,
      subtitle,
      isEddABTest,
      isLoyaltyTieringEnabled,
      hasExpeditedProcessing,
    } = this.props;
    const {
      lbl_edd_arrivesby: arrivesBy,
      lbl_preorder_items_edd: preOrderItemEdd,
      lbl_estimate_to_arrive: estimateToArriveBy,
    } = getLabelFromCopyOrFromTranslation('checkout.bagPage', BAGPAGE_LABELS);

    const checkoutLabels = getLabelFromCopyOrFromTranslation(CHECKOUT_LABELS, AccountCommonLabels);

    const {
      lbl_holiday_message_confirmation: holidayMessageConfirmation,
      lbl_holiday_date: holidayDate,
      lbl_holiday_message: holidayMessage,
    } = getDynamicLabelValues('dynamic.cart');

    const eddLabels = {
      arrivesBy,
      preOrderItemEdd,
      estimateToArriveBy,
      holidayMessageConfirmation,
      holidayDate,
      holidayMessage,
    };

    const eddItemsForId = filterEddItemsById(itemsWithEdd, itemIdprop);
    if (getEddSessionState(isEddABTest)) {
      const mainView = isRangeDate
        ? this.renderRangeView(selectedShipment, subtitle, eddLabels)
        : this.renderDateView(eddItemsForId, eddLabels);
      return (
        <>
          {mainView}
          {isLoyaltyTieringEnabled &&
            hasExpeditedProcessing &&
            this.renderExpeditedProcessing(checkoutLabels)}
        </>
      );
    }
    return null;
  }
}

EddComponentView.propTypes = {
  className: PropTypes.string,
  subtitle: PropTypes.string,
  itemsWithEdd: PropTypes.shape({}),
  orderEddDates: PropTypes.shape({}),
  itemIdprop: PropTypes.string,
  isRangeDate: PropTypes.bool,
  showIcon: PropTypes.bool,
  selectedShipment: PropTypes.string,
  isShipping: PropTypes.bool,
  fontSize: PropTypes.string,
  textAlign: PropTypes.string,
  fetchEdd: PropTypes.func.isRequired,
  isEddABTest: PropTypes.bool,
  fetchEddUpdate: PropTypes.func.isRequired,
  selectedShippingMethod: PropTypes.string,
  updateShipmentCode: PropTypes.func,
  spcBag: PropTypes.bool,
  spc: PropTypes.bool,
  myBagSpc: PropTypes.bool,
  shippingMethodSelected: PropTypes.shape({}).isRequired,
  isFromShippingExpanded: PropTypes.bool,
  isLoyaltyTieringEnabled: PropTypes.bool,
  hasExpeditedProcessing: PropTypes.bool,
  currentTier: PropTypes.string,
};

EddComponentView.defaultProps = {
  className: '',
  subtitle: '',
  itemsWithEdd: null,
  orderEddDates: {},
  itemIdprop: null,
  isRangeDate: false,
  showIcon: false,
  selectedShipment: '',
  isShipping: false,
  fontSize: '',
  textAlign: '',
  isEddABTest: false,
  selectedShippingMethod: null,
  updateShipmentCode: () => {},
  spcBag: false,
  spc: false,
  myBagSpc: false,
  isFromShippingExpanded: false,
  isLoyaltyTieringEnabled: false,
  hasExpeditedProcessing: false,
  currentTier: '',
};

export default withStyles(EddComponentView, Styles);
export { EddComponentView as EddComponentViewVanilla };
